// 活动规则
import { Carousel } from 'antd';
import { RootObject, Content9, ContentBlock2 } from '../../type';
import './style.less';

const ExpertReview = (props: RootObject["expertReview"]) => {
    const {
        zhTitle,
        enTitle,
        content
    } = props;
    return (
        <div className='p-p-foundathon-expertReview'>
            <div className='p-p-foundathon-expertReview-zh-title'>
                {
                    zhTitle ?? ''
                }
            </div>
            <div className='p-p-foundathon-expertReview-en-title'>
                {
                    enTitle ?? ''
                }
            </div>
            <div className='p-p-foundathon-expertReview-modules'>
                <Carousel autoplay className='p-p-foundathon-expertReview-modules-carousel'>
                    {
                        content.map((item: Content9, index: number) => {
                            return (
                                <div  key={index}>
                                    <div className='p-p-foundathon-expertReview-modules-module'>
                                        {
                                            item?.contentBlock?.map((el: ContentBlock2, i: number) => {
                                                return (
                                                    <div className='p-p-foundathon-expertReview-modules-module-item' key={i} style={{ backgroundImage: `url(${el.Img})` }} >
                                                        <div className='p-p-foundathon-expertReview-modules-module-item-b'>
                                                            <div className='p-p-foundathon-expertReview-modules-module-item-b-back'></div>
                                                            <div className='p-p-foundathon-expertReview-modules-module-item-b-title'>
                                                                {
                                                                    el.title ?? ''
                                                                }
                                                            </div>
                                                            <div className='p-p-foundathon-expertReview-modules-module-item-b-desc'>
                                                                {
                                                                    el.desc ?? ''
                                                                }
                                                            </div>
                                                        </div>

                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </Carousel>
            </div>
        </div>
    )
}

export default ExpertReview;